// ============================================================
//  ترويسة رسمية موحدة لجميع التقارير والبيانات المطبوعة
//  مراقبة التشغيل - محطة الصبية
//  تتطلب الشعار الرسمي الكامل في: public/forms/logo.png
// ============================================================
import React from 'react';

export default function OfficialHeader({ title, subtitle }) {
  return (
    <div className="official-header" style={{ direction: 'rtl', marginBottom: 16, color: '#0b1f4d', width: '100%' }}>
      <div
        className="official-header-row"
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr 1fr',
          alignItems: 'start',
          gap: 16,
          direction: 'ltr',
          borderBottom: '2px solid #0b1f4d',
          paddingBottom: 9,
          minHeight: 78
        }}
      >
        <div style={{ textAlign: 'left', direction: 'ltr' }}>
          <img
            src="/forms/logo.png"
            alt="شعار وزارة الكهرباء والماء"
            style={{ width: 118, maxWidth: '100%', height: 'auto', display: 'block' }}
          />
        </div>

        <div style={{ textAlign: 'center', direction: 'rtl', paddingTop: 12 }}>
          <div style={{ fontWeight: 700, fontSize: 18, letterSpacing: 0.2 }}>مراقبة التشغيل</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 9, justifyContent: 'center', marginTop: 7 }}>
            <span style={{ width: 92, borderTop: '1.5px solid #0b1f4d' }} />
            <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#0b1f4d', display: 'inline-block' }} />
            <span style={{ width: 92, borderTop: '1.5px solid #0b1f4d' }} />
          </div>
        </div>

        <div style={{ textAlign: 'right', direction: 'rtl', fontWeight: 700, fontSize: 14, lineHeight: 1.55, paddingTop: 7 }}>
          محطة الصبية<br />لتوليد القوى الكهربائية<br />وتقطير المياه
        </div>
      </div>

      {title && (
        <div style={{ textAlign: 'center', marginTop: 18, fontWeight: 700, fontSize: 20, color: '#0b1f4d' }}>
          {title}
        </div>
      )}
      {subtitle && (
        <div style={{ textAlign: 'center', marginTop: 6, fontSize: 13, color: '#444', fontWeight: 500 }}>
          {subtitle}
        </div>
      )}
    </div>
  );
}
